import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { debounce, forEach, groupBy } from "lodash";
import { BehaviorSubject, Observable, Subject, forkJoin } from "rxjs";
import { map, mergeMap, takeUntil, tap } from "rxjs/operators";
import { MenuButtonComponent , MenuButtonComponent as MenuButtonComponent_1 } from "~app/common/components/menu-button/menu-button.component";
import { IMessageModel } from "~app/common/components/message-panel/message-panel.models";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { CommandService } from "~app/common/services/cqs/command.service";
import { EventService } from "~app/common/services/cqs/event.service";
import { StringUtils } from "~app/common/utils/string-utils";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import { IValidationScope } from "~app/common/validation/IValidationScope";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import {
    InitiateArbetsorderViol3SynchronizationCommand
} from "~app/features/administration/systemadministration/tabs/sysadm-viol3/commands/InitiateArbetsorderViol3SynchronizationCommand";
import { ArbetsorderHandelssortimentDetailsComponent } from "~app/features/planera/arbetsorder-handelssortiment-details/arbetsorder-handelssortiment-details.component";

import { DatePipe, NgClass, NgTemplateOutlet } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ActionButtonComponent } from "@components/action-button/action-button.component";
import { HeaderComponent } from "@components/header/header.component";
import { IconButtonComponent } from "@components/icon-button/icon-button.component";
import { InfoComponent } from "@components/info/info.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { LabelComponent } from "@components/label/label.component";

import {
    ArbetsorderViol3JusteraMatningsinformationComponent
} from "~app/features/planera/arbetsorder-viol3-justera-matningsinformation/arbetsorder-viol3-justera-matningsinformation.component";
import { ArbetsorderDisabledFlag } from "~app/features/planera/model/ArbetsorderDisabledFlag";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import {
    DestineringsraderUpdatedEvent
} from "~app/features/transport/transportplanera/components/tpl-omdestinera/components/begransa-virkesorderrader-modal/begransa-virkesorderrader-events";
import {
    AnvandVerkligaAvlaggChangedEvent,
    RuttChangedEvent,
    RuttExtraKmChangedEvent
} from "~app/features/transport/transportplanera/components/tpl-transportavstand-modal/tpl-transportavstand-eventhandler";
import { TplTransportavstandModalComponent } from "~app/features/transport/transportplanera/components/tpl-transportavstand-modal/tpl-transportavstand-modal.component";

import { KilometerPipe } from "../../../common/pipes/kilometer.pipe";
import { ValidationMessageContainerComponent } from "../../../common/validation/validation-message-container/validation-message-container.component";
import { ValidationMessageRowComponent } from "../../../common/validation/validation-message-row/validation-message-row.component";
import { ValidationRuleDirective } from "../../../common/validation/validation-rule.directive";
import { ArbetsorderKontraksraderComponent } from "../arbetsorder-kontraksrader/arbetsorder-kontraksrader.component";
import { ArbetsorderViol3DestineringsraderComponent } from "../arbetsorder-viol3-destineringsrader/arbetsorder-viol3-destineringsrader.component";
import { DestineraArbetsorderHandelssortimentCommand } from "../commands/DestineraArbetsorderHandelssortimentCommand";
import { MergeAllDestineringsalternativCommand } from "../commands/MergeAllDestineringsalternativCommand";
import { ArbetsorderHandelssortimentAddedEventMessage } from "../events/ArbetsorderHandelssortimentAddedEventMessage";
import { ArbetsorderHandelssortimentDeletedEventMessage } from "../events/ArbetsorderHandelssortimentDeletedEventMessage";
import * as DestineringEvents from "../events/DestineringAttributEventMessage";
import { DestineringsalternativMergeCompletedEventMessage } from "../events/DestineringsalternativMergeCompletedEventMessage";
import { TransportavstandBerakningCompletedEventMessage } from "../events/TransportavstandBerakningCompletedEventMessage";
import { ArbetsorderMediatorService } from "../services/arbetsorder-mediator.service";
import { ArbetsorderMonitor, ArbetsorderMonitorService } from "../services/arbetsorder-monitor.service";
import { ArbetsorderService, GetArbetsorderDestineringsalternativQueryResult } from "../services/arbetsorder.service";
import { EventHandler } from "./arbetsorder-destineringsalternativ.event.handler";
import { ArbestorderDestineringsalternativViewModel, ArbetsorderHandelssortimentViewModel, DestineringsalternativViewModel } from "./arbetsorder-destineringsalternativ.models";
import { ArbetsorderDestineringsalternativValidation } from "./arbetsorder-destineringsalternativ.validation";
import { ArbetsorderDestineringsalternativManuellaComponent, IDestineringsalternativManuellaItemRad } from "./manuella/arbetsorder-destineringsalternativ-manuella.component";

@Component({
    selector: "rask-arbetsorder-destineringsalternativ",
    templateUrl: "./arbetsorder-destineringsalternativ.component.html",
    styleUrls: ["./arbetsorder-destineringsalternativ.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        LabelComponent,
        MenuButtonComponent_1,
        ActionButtonComponent,
        HeaderComponent,
        IconButtonComponent,
        NgTemplateOutlet,
        ValidationMessageRowComponent,
        NgClass,
        InfoComponent,
        InputNumberComponent,
        FormsModule,
        ValidationRuleDirective,
        ValidationMessageContainerComponent,
        DatePipe,
        KilometerPipe
    ]
})
export class ArbetsorderDestineringsalternativComponent implements OnInit, OnDestroy {
    readonly authenticationService = inject(AuthenticationService);

    arbetsorder: IArbetsorderDetail;
    @Output() asyncProgressOutput = new EventEmitter<boolean>();
    @Output() commandOutput = new EventEmitter<DestineraArbetsorderHandelssortimentCommand>();
    hasEditRole: boolean;
    @ViewChild("menu") menuBtn: MenuButtonComponent;
    validation: IValidationScope;
    @Output() validationOutput = new EventEmitter<boolean>();
    viewModel: ArbestorderDestineringsalternativViewModel;

    private readonly alerts$ = new BehaviorSubject<IMessageModel[]>([]);
    private readonly arbetsorderMediatorService = inject(ArbetsorderMediatorService);
    private readonly arbetsorderMonitorService = inject(ArbetsorderMonitorService);
    private readonly arbetsorderService = inject(ArbetsorderService);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly commandService = inject(CommandService);
    private readonly debouncedSetupValidation = debounce(() => {
        this.setupValidation();
    }, 1000);
    private readonly eventService = inject(EventService);
    private readonly modalService = inject(NgbModal);
    private readonly monitor: ArbetsorderMonitor;
    private readonly ngUnsubscribe$ = new Subject<void>();
    private readonly raskModalService = inject(RaskModalService);

    private eventHandler: EventHandler;
    private validationContext: IValidationContext;

    constructor() {
        const authenticationService = this.authenticationService;

        this.hasEditRole = authenticationService.canEdit();
        this.monitor = this.arbetsorderMonitorService.connect();
    }

    get canEdit(): boolean {
        return this.hasEditRole && this.arbetsorder.isEditableForMode(ArbetsorderDisabledFlag.makulerad) && !this.arbetsorder.isExternArbetsorder;
    }

    get canEditAndel(): boolean {
        return this.hasEditRole && this.arbetsorder.isEditableForMode(ArbetsorderDisabledFlag.makulerad);
    }

    get canEditManuellaDestineringsalternativ(): boolean {
        return this.hasEditRole && this.arbetsorder.isEditableForMode(ArbetsorderDisabledFlag.makulerad) && !this.arbetsorder.isExternArbetsorder;
    }

    get canMergeDestineringsalternativ(): boolean {
        return this.hasEditRole && this.arbetsorder.isEditableForMode(ArbetsorderDisabledFlag.makulerad);
    }

    get canUpdateViol(): boolean {
        return this.hasEditRole && this.arbetsorder.isEditableForMode(ArbetsorderDisabledFlag.makulerad) &&
         (!this.arbetsorder.isExternArbetsorder || this.arbetsorder.viol3);
    }

    get hasRaskVo(): boolean {
        return this.arbetsorder?.raskVo;
    }

    get interpretEmptyAsError(): boolean {
        if (!this.arbetsorder.isGrotskotning) {
            return true;
        }
        return !!this.arbetsorder.transportforetagId;
    }

    get transporttidApplicable(): boolean {
        return !this.arbetsorder.isGrotskotning;
    }

    editTransportavstand(alternativ: DestineringsalternativViewModel): void {
        const ao = {
            id: this.arbetsorder.id,
            beteckning: this.arbetsorder.beteckning,
            namn: this.arbetsorder.namn,
            raskVo: this.arbetsorder.raskVo,
            viol3: this.arbetsorder.viol3,
            anvandVerkligaAvlagg: this.arbetsorder.anvandVerkligaAvlagg
        };

        TplTransportavstandModalComponent.open(ao,
            alternativ.arbetsorderHandelssortiment.handelssortimentId,
            alternativ.mottagningsplatsId,
            "standard",
            "planera",
            this.modalService);
    }

    initViewModel(): Observable<void> {
        const ahs$ = this.arbetsorderService.getArbetsorderHandelssortiment(this.arbetsorder.id);
        const destineringar$ = this.arbetsorderService.getDestineringsalternativ(this.arbetsorder.id);

        return forkJoin([
            ahs$,
            destineringar$
        ])
            .pipe(
                map(results => {
                    const ahs = results[0].arbetsorderHandelssortiment;
                    const destineringResult = results[1];

                    this.patchFromPendingCommands(destineringResult);

                    const result = new ArbestorderDestineringsalternativViewModel(ahs, destineringResult.destineringsalternativ);
                    this.viewModel = result;
                    this.setupValidation();
                })
            );
    }

    mergeAllDestineringsalternativ(): void {
        this.menuBtn.toggle();
        this.asyncProgressOutput.emit(true);

        const command = new MergeAllDestineringsalternativCommand(x => x.arbetsorderId = this.arbetsorder.id);

        // Detta command körs alltid isolerat - oavsett vad som ligger i stacken hos commandService
        const local = this.commandService.createInstance();
        local.addTransactionCommand(command);

        const work = local.pushCommandQueueTransaction()
            .pipe(mergeMap(x => this.initViewModel()));

        work.subscribe(x => {
            this.asyncProgressOutput.emit(false);
        });
    }

    ngOnDestroy(): void {
        this.eventHandler?.unsubscribe();
        this.monitor.disconnect();
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    ngOnInit(): void {
        this.arbetsorderMediatorService.arbetsorder
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(changeEvent => {
                this.arbetsorder = changeEvent?.arbetsorderWrapper?.arbetsorder;

                if (changeEvent?.isClosed()) {
                    this.eventHandler?.unsubscribe();
                } else if (changeEvent?.isDifferent()) {
                    this.eventHandler?.unsubscribe();
                    this.setupEvents();
                }
            });
    }

    onAndelChanged(newAndel: number, alternativ: DestineringsalternativViewModel): void {
        const cmd = new DestineraArbetsorderHandelssortimentCommand(
            this.arbetsorder.id,
            alternativ.id,
            alternativ.andel);

        this.commandOutput.emit(cmd);
        this.validationOutput.emit(this.validationContext.validate());
    }

    openAvstandNarmasteIndustri(hs: ArbetsorderHandelssortimentViewModel): void {
        const data = {
            arbetsorderId: this.arbetsorder.id,
            arbetsorderHandelssortimentId: hs.id
        };

        this.raskModalService.open(
            `Avstånd närmaste industri - ${hs.handelssortimentNamn}`,
            ArbetsorderHandelssortimentDetailsComponent,
            "lg",
            true,
            data);
    }

    openKontraktsrader(alternativ: DestineringsalternativViewModel): void {
        const data = {
            arbetsorderId: this.arbetsorder.id,
            canEdit: this.canEdit,
            alternativ: alternativ
        };
        this.raskModalService.open(
            `${alternativ.arbetsorderHandelssortiment.handelssortimentNamn} - ${alternativ.mottagningsplatsNamn} ${alternativ.mottagningsplatsnummer}`,
            ArbetsorderKontraksraderComponent,
            "xl",
            true,
            data);
    }

    openManuellaDestineringsalternativ() {
        this.menuBtn.toggle();
        const valdaManuella: IDestineringsalternativManuellaItemRad[] = [];
        this.viewModel.arbetsorderHandelssortiment.forEach(hs => {
            hs.destineringsalternativ
                .filter(x => x.isManuellRad)
                .forEach(da => {
                    valdaManuella.push({
                        foradlatHandelssortimentId: da.foradlatHandelssortimentId,
                        handelssortimentId: da.arbetsorderHandelssortiment.handelssortimentId,
                        mottagningsplatsId: da.mottagningsplatsId
                    });
                });
        });

        const data = {
            arbetsorder: this.arbetsorder,
            valdaManuellaRader: valdaManuella,
            checkAddArbetsorderIntressent: false
        };

        this.raskModalService.openAsync(
            "Manuella destineringsalternativ",
            ArbetsorderDestineringsalternativManuellaComponent,
            "lg",
            true,
            data)
            .subscribe((response) => {
                this.initViewModel().subscribe();
            });
    }

    openViol3Destineringsrader(alternativ: DestineringsalternativViewModel): void {
        const data = {
            arbetsorderId: this.arbetsorder.id,
            alternativ: alternativ,
            editable: this.canEdit
        };
        this.raskModalService.open(
            `${alternativ.arbetsorderHandelssortiment.handelssortimentNamn} - ${alternativ.mottagningsplatsNamn} ${alternativ.mottagningsplatsnummer}`,
            ArbetsorderViol3DestineringsraderComponent,
            "xl",
            true,
            data);
    }

    openViol3JusteraMatningsinformation(): void {
        const data = {
            arbetsorderId: this.arbetsorder.id,
            skickadTillViol3: this.arbetsorder.skickadTillViol3,
            canEdit: this.canEdit
        };
        this.raskModalService.open(
            `Viol3 mätningsinformation för - ${this.arbetsorder.beteckning} ${this.arbetsorder.namn}`,
            ArbetsorderViol3JusteraMatningsinformationComponent,
            "xl",
            true,
            data);
    }

    patchFromPendingCommands(destineringResult: GetArbetsorderDestineringsalternativQueryResult) {
        this.arbetsorder.commandManager
            .getStack()
            .filter(p => p.$type === DestineraArbetsorderHandelssortimentCommand.$type)
            .map(g => {
                const command = g as DestineraArbetsorderHandelssortimentCommand;
                return {
                    command: command,
                    destineringsalternativ: destineringResult.destineringsalternativ.filter(dest => dest.id === command.destineringId)[0]
                };
            })
            .filter(g => g.destineringsalternativ)
            .forEach(pair => {
                pair.destineringsalternativ.andel = pair.command.andel;
            });
    }

    updateFromViol(): void {
        this.menuBtn.toggle();
        this.asyncProgressOutput.emit(true);
        const commandService = this.commandService.createInstance();

        if (this.arbetsorder.viol3) {
            const command = new InitiateArbetsorderViol3SynchronizationCommand(x => x.arbetsorderId = this.arbetsorder.id);
            commandService.addTransactionCommand(command);
            commandService.pushCommandQueueTransaction().subscribe(x => {
                this.asyncProgressOutput.emit(false);
            });
        }
    }

    writeMottagningsplats(alternativ: DestineringsalternativViewModel) {
        if (alternativ.foradlatHandelssortimentId == null) {
            return alternativ.mottagningsplatsNamn;
        }

        return StringUtils.suffixString(alternativ.mottagningsplatsNamn, "//FLIS", 20);
    }

    private doDebounce(): void {
        this.validation = undefined;
        this.debouncedSetupValidation.cancel();
        this.debouncedSetupValidation();
    }

    private onAlert(messages: IMessageModel[]): void {
        // I viol3 ligger alla meddelanden i alertproviders så vi kan rensa alla meddelnaden innan vi lägger in dom igen.
        // För viol2 finns inte alla destineringsattribut i alertproviders och kan därför inte rensas.
        if (this.arbetsorder.viol3) {
            this.viewModel.arbetsorderHandelssortiment.forEach(x => {
                x.destineringsalternativ.forEach(y => {
                    y.alertValidationMessage = null;
                });
            });
        }

        forEach(groupBy(messages, msg => msg.metadata?.destineringId), messageArr => {
            const destineringId = parseInt(messageArr[0].metadata?.destineringId, 10);
            const values = messageArr.map(p => p.message).join(", ");
            this.viewModel.setAlert(destineringId, values);
        });

        this.changeDetectorRef.detectChanges();
    }

    private onAnvandVerkligaAvlaggChanged(event: AnvandVerkligaAvlaggChangedEvent) {
        if (event.arbetsorderId !== this.arbetsorder.id) {
            return;
        }
        this.arbetsorder.anvandVerkligaAvlagg = event.anvandVerkligaAvlagg;
    }

    private onArbetsorderHandelssortimentAdded(e: ArbetsorderHandelssortimentAddedEventMessage): void {
        this.arbetsorderService
            .getArbetsorderHandelssortiment(e.arbetsorderId, e.arbetsorderHandelssortimentId)
            .subscribe(x => {
                this.viewModel.addArbetsorderHandelssortiment(x.arbetsorderHandelssortiment);
                this.changeDetectorRef.detectChanges();

                this.doDebounce();
            });
    }

    private onArbetsorderHandelssortimentDeleted(e: ArbetsorderHandelssortimentDeletedEventMessage): void {
        this.viewModel.removeArbetsorderHandelssortiment(e.arbetsorderHandelssortimentId);
        this.changeDetectorRef.detectChanges();

        this.doDebounce();
    }

    private onDestineringraderUpdated(event: DestineringsraderUpdatedEvent) {
        this.viewModel.arbetsorderHandelssortiment.forEach(ah => {
            ah.destineringsalternativ.forEach(d => {
                const isInaktiv = event.inaktivaDestineringar.filter(x => x === d.id);
                d.aktiv = isInaktiv.length > 0 ? false : true;
            });
        });
    }

    private onDestineringsalternativMergeCompleted(e: DestineringsalternativMergeCompletedEventMessage): void {
        this.arbetsorderService.getDestineringsalternativ(this.arbetsorder.id).subscribe(x => {
            this.viewModel.mergeDestineringsalternativ(e.arbetsorderHandelssortimentIdList, x.destineringsalternativ);
            this.changeDetectorRef.detectChanges();

            this.doDebounce();
        });
    }

    private onRuttChanged(event: RuttChangedEvent) {
        this.ruttChanged(event);
    }

    private onRuttExtraKmChangedEvent(event: RuttExtraKmChangedEvent) {
        this.ruttChanged(event);
    }

    private onTransportavstandBerakningCompleted(e: TransportavstandBerakningCompletedEventMessage): void {
        this.arbetsorderService.getDestineringsalternativ(this.arbetsorder.id).subscribe(x => {
            const applicable = x.destineringsalternativ.filter(dto => e.destineringIdList.includes(dto.id));
            this.viewModel.updateDestineringsalternativ(applicable);
            this.changeDetectorRef.detectChanges();
        });
    }

    private onVirkesorderValidation(e: DestineringEvents.DestineringAttributEventMessage): void {
        this.viewModel.setAlert(e.destineringId, e.varde);
        this.changeDetectorRef.detectChanges();
    }

    private ruttChanged(event: any): void {
        if (event.arbetsorderId !== this.arbetsorder.id) {
            return;
        }
        this.initViewModel().subscribe();
    }

    private setupEvents() {
        this.initViewModel().subscribe();

        this.eventHandler = new EventHandler(this.arbetsorder.id, this.eventService);
        this.eventHandler.onArbetsorderHandelssortimentDeleted(event => this.onArbetsorderHandelssortimentDeleted(event));
        this.eventHandler.onArbetsorderHandelssortimentAdded(event => this.onArbetsorderHandelssortimentAdded(event));
        this.eventHandler.onVirkesorderValidation(event => this.onVirkesorderValidation(event));
        this.eventHandler.onRuttChanged(event => this.onRuttChanged(event));
        this.eventHandler.onRuttExtraKmChanged(event => this.onRuttExtraKmChangedEvent(event));
        this.eventHandler.onDestineringraderUpdated(event => this.onDestineringraderUpdated(event));
        this.eventHandler.onDestineringsalternativMergeCompleted(event => this.onDestineringsalternativMergeCompleted(event));
        this.eventHandler.onTransportavstandBerakningCompleted(event => this.onTransportavstandBerakningCompleted(event));
        this.eventHandler.onAnvandVerkligaAvlaggChanged(event => this.onAnvandVerkligaAvlaggChanged(event));
    }

    private readonly setupValidation = (): void => {
        this.monitor.alerts$
            .pipe(
                tap(x => {
                    const applicableDestineringAlerts = x.filter(s => s.metadata?.destineringId);
                    this.onAlert(applicableDestineringAlerts);
                    this.alerts$.next(x);
                }),
                takeUntil(this.ngUnsubscribe$)
            ).subscribe(x => this.changeDetectorRef.detectChanges());

        this.validationContext = ArbetsorderDestineringsalternativValidation.init(this.viewModel);
        this.validationContext.scope(ValidationScopes.spara).subscribe(v => {
            this.validation = v;
        });
        this.validationOutput.emit(this.validationContext.validate());
    };
}
